import { createAction } from "@reduxjs/toolkit";

import { GetSubscriptionPriceResponseDto } from "utils/swagger_react_query";

import { SET_SUBSCRIPTION_PRICES } from "../constants/ActionTypes";

export const setSubscriptionPrices = createAction<
  GetSubscriptionPriceResponseDto | null,
  typeof SET_SUBSCRIPTION_PRICES
>(SET_SUBSCRIPTION_PRICES);
